// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./client/react/Admin/views/Transactions/home.css
// module id = 1069
// module chunks = 0